import Cookies from 'universal-cookie';
import { buttonStateMap } from '../../constant';
import { UPDATE_BUTTON_STATES } from '../types';

const cookies = new Cookies();

export function process(
  state = {
    validationText: '',
    buttonState: cookies.get('Rz') ? buttonStateMap.ENABLED : buttonStateMap.LOGIN,
    isChecked: false,
  },
  action
) {
  switch (action.type) {
    case UPDATE_BUTTON_STATES: {
      return {
        ...state,
        ...action.buttonState,
      };
    }
    default:
      return state;
  }
}

export default function buttonStates(state = {}, action = {}) {
  switch (action.type) {
    case UPDATE_BUTTON_STATES:
      return {
        ...state,
        [action.cId]: process(state[action.cId], action),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/buttonStateByCId.js